import { CONCAT_TEXT_LIMIT, HEADER_TAB_SETUP } from "../../functions/funtion";
import { api_FilterMerchantsNProducts } from "../../connection/api/api-home";
import { PT_HOME, PT_MASTERCATEGORY } from "../../routes/stack/paths/pt-home";
import { CSP, ENCRYPT_STORAGE } from "../../config/config";
import { GET_SET_STORED_DATA } from "../../database/get-stored-data";
import { STORE_MERCHANT } from "../../database/store-names";
import { ToastMessage } from "../../components/toast-notification/toast";
import { dto_common } from "../../classes/dto-common";
import { F_Fammily } from "../../util/config-fonts";
import { Colors } from "../../util/colors";
import FilterMerchantCard from "./components/pg-filter-outlets-products/merchant-card";
import ViewFilterItem from "./components/pg-filter-outlets-products/view-filter-item";
import PlaceHolder from "./components/product-list-place-holder/product-list-place-holder";
import React from "react";
import "../../styles/css/pg-filter-outlets-products.css";

export default class FilterOutletsProducts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Type: 1,
      SearchString: "",
      AllMerchantData: [],
      ProductData: [],
      MerchantData: [],
      IsLoading: false,
      ActiveIndex: 0,
      merchantDisplayBtn: "none",
      height: 24,
      MerchatLength: 1,
      HasSearched: false,
    };

    this.focusSearchInput = this.focusSearchInput.bind(this);
  }

  async componentDidMount() {
    await GET_SET_STORED_DATA();
    const StoredMerchantData = ENCRYPT_STORAGE.getItem(STORE_MERCHANT) || [];

    await HEADER_TAB_SETUP({
      HeaderTabName: CONCAT_TEXT_LIMIT({
        length: 20,
        string: "Search",
      }),
      FnGoBackScreen: () => {
        if (this.props.params.frmpath.toUpperCase() === "HOME") {
          this.props.navigate(PT_HOME);
        } else if (this.props.params.frmpath.toUpperCase() === "CATEGORY") {
          this.props.navigate(PT_MASTERCATEGORY);
        }
      },
      HeaderNavigatorMenuDisplay: false,
      FnHeaderNavigatorMenu: () => {},
    });

    let MerchatLength = StoredMerchantData;
    if (MerchatLength.length === 1) {
      this.setState({
        Type: 2,
        AllMerchantData: StoredMerchantData,
        MerchantData: [],
        ProductData: [],
        ActiveIndex: 1,
        merchantDisplayBtn: "none",
        height: 0,
        MerchatLength: 1,
      });
    } else {
      this.setState({
        Type: 1,
        AllMerchantData: StoredMerchantData,
        MerchantData: [],
        ProductData: [],
        ActiveIndex: 0,
        merchantDisplayBtn: "block",
        height: 24,
        MerchatLength: parseInt(MerchatLength.length),
      });
    }

    if (CSP === "MK") {
      this.setState({
        Type: 2,
        ActiveIndex: 1,
        merchantDisplayBtn: "none",
        height: 0,
      });
    }

    if (this.props.params.frmpath.toUpperCase() === "CATEGORY") {
      let SearchStringFilter = ENCRYPT_STORAGE.getItem("SearchStringFilter");
      if (SearchStringFilter) {
        ENCRYPT_STORAGE.removeItem("SearchStringFilter");
        document.getElementById("FilterTextBox").value = SearchStringFilter;
        this.setState({ SearchString: SearchStringFilter }, () => {
          this.SearchData();
        });
      }
    }

    this.focusSearchInput();
  }

  focusSearchInput() {
    if (this.searchInput && this.searchInput.focus) {
      setTimeout(() => {
        this.searchInput.focus();
      }, 0);
    }
  }

  SetType(Type) {
    this.setState(
      {
        Type: Type,
        MerchantData: [],
        ProductData: [],
        SearchString: "",
        HasSearched: false,
      },
      () => {
        this.focusSearchInput();
      },
    );
  }

  async SearchData() {
    const SearchString = this.state.SearchString.trim();

    if (this.state.Type === 1) {
      const MerchantDataSource =
        this.state.AllMerchantData && this.state.AllMerchantData.length > 0
          ? this.state.AllMerchantData
          : ENCRYPT_STORAGE.getItem(STORE_MERCHANT) || [];

      const FilteredMerchants =
        SearchString.length === 0
          ? []
          : MerchantDataSource.filter((merchant) =>
              (merchant.Merchant || "")
                .toLowerCase()
                .includes(SearchString.toLowerCase()),
            );

      this.setState({
        MerchantData: FilteredMerchants,
        ProductData: [],
        IsLoading: false,
        HasSearched: SearchString.length > 0,
      });
      return;
    }

    if (SearchString.length >= 3) {
      this.setState({
        IsLoading: true,
        MerchantData: [],
        ProductData: [],
        HasSearched: true,
      });
      if (CSP !== "AV") {
        if (dto_common.ZoneId === 0) {
          dto_common.ZoneId = 1;
          dto_common.ZoneDescription = "Dehiwala";
        }
      }
      let data = await api_FilterMerchantsNProducts(
        this.state.Type,
        SearchString,
      );
      let objData = JSON.parse(data);

      this.setState(
        {
          MerchantData: objData[0].MerchantList,
          ProductData: objData[1].ProductList,
          IsLoading: false,
        },
        () => {},
      );
    } else {
      // Alert.MessageBox({
      //   Tittle: "Info",
      //   Icon: "error",
      //   ConfirmButtonText: "Okay",
      //   Text: "Search box must contain atleast three letters",
      // });

      await ToastMessage(
        1,
        "Search box must contain atleast three letters for product search",
      );
    }
  }

  render() {
    return (
      <>
        <div
          className="pgFilterLayout fadeInDown animated"
          style={{
            position: "sticky",
            top: 0,
            width: "100%",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            zIndex: 1500,
          }}
        >
          {CSP === "MK" ? (
            <div
              className="SwitchBox"
              style={{ display: "flex", flexDirection: "row" }}
            >
              <div
                className="switchButtonSS"
                style={{
                  marginLeft: "2%",
                  marginRight: "2%",
                  cursor: "default",
                  pointerEvents: "none",
                  fontWeight: "bold",
                }}
              >
                PRODUCTS
              </div>
            </div>
          ) : (
            <>
              <div
                className="SwitchBox"
                style={{ display: "flex", flexDirection: "row" }}
              >
                <div
                  className="switchButtonS"
                  onClick={() => {
                    this.SetType(1);
                    document.getElementById("FilterTextBox").value = "";
                    this.setState({ ActiveIndex: 0 });
                  }}
                  style={{
                    marginLeft: "2%",
                    background:
                      this.state.ActiveIndex === 0
                        ? "WHITE"
                        : Colors.LightGreyScale,
                    color: "black",
                  }}
                >
                  MERCHANTS
                </div>

                <div
                  className="switchButtonS"
                  onClick={() => {
                    this.SetType(2);
                    document.getElementById("FilterTextBox").value = "";
                    this.setState({ ActiveIndex: 1 });
                  }}
                  style={{
                    marginRight: "2%",
                    background:
                      this.state.ActiveIndex === 1
                        ? "WHITE"
                        : Colors.LightGreyScale,
                    color: "black",
                  }}
                >
                  PRODUCTS
                </div>
              </div>
            </>
          )}

          <div className="pgFilterBtnGrp">
            <input
              type="text"
              placeholder={
                this.state.Type === 1 ? "Search Merchant" : "Search Product"
              }
              inputMode="search"
              id="FilterTextBox"
              ref={(input) => (this.searchInput = input)}
              onChange={(e) => {
                const SearchString = e.currentTarget.value;
                this.setState({ SearchString }, () => {
                  if (this.state.Type === 1) {
                    this.SearchData();
                  }
                });
              }}
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  this.SearchData();
                }
              }}
              style={{
                fontFamily: F_Fammily.Regular,
                backgroundColor: "white",
                color: "black",
                paddingLeft: "10px",
              }}
            />
            <button
              style={{ backgroundColor: Colors.DarkGreyScale }}
              onClick={() => {
                this.SearchData();
              }}
            >
              <i className="fa fa-search" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <div
          style={{
            marginTop: "8px",
            marginBottom: 55,
          }}
        >
          {this.state.IsLoading ? (
            <PlaceHolder />
          ) : (
            <div>
              {this.state.MerchantData.length === 0 &&
              this.state.ProductData.length === 0 ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "80px",
                  }}
                >
                  <img
                    src={require("./images/NoDataFound.jpg")}
                    width={"60%"}
                    alt=""
                  />

                  {this.state.HasSearched ? (
                    <>
                      <label
                        style={{
                          fontWeight: "bold",
                          marginBottom: "8px",
                          textAlign: "center",
                        }}
                      >
                        No Data Found
                      </label>
                      <label
                        style={{
                          textAlign: "center",
                          display: "block",
                        }}
                      >
                        Try searching for something else
                      </label>
                    </>
                  ) : null}
                </div>
              ) : (
                <>
                  <>
                    {this.state.MerchantData &&
                      this.state.MerchantData.map((rs, i) => {
                        return (
                          <FilterMerchantCard
                            key={rs.PI + "FilterItem" + i}
                            data={rs}
                            navigate={this.props.navigate}
                          />
                        );
                      })}
                  </>
                  <>
                    {this.state.ProductData.map((rs, i) => {
                      return (
                        <ViewFilterItem
                          pmData={rs}
                          Name={rs.NAME}
                          key={rs.PI + "FilterItem" + i}
                          navigate={this.props.navigate}
                        />
                      );
                    })}
                  </>
                </>
              )}
            </div>
          )}
        </div>
      </>
    );
  }
}
